var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('AppBar'),_c('v-main',{staticClass:"bg-gray",staticStyle:{"padding-top":"0 !important"}},[_c('router-view')],1),_c('AppFoot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }